// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SingleFieldLookupAddressForm-module-container-3mA-j{display:flex;flex-direction:column}.SingleFieldLookupAddressForm-module-inputContainer-3HkVw{margin-bottom:24px}.SingleFieldLookupAddressForm-module-inputContainer-3HkVw:last-child{margin-bottom:0}.SingleFieldLookupAddressForm-module-postcodeInput-17xaL:-moz-read-only{pointer-events:none}.SingleFieldLookupAddressForm-module-postcodeInput-17xaL:read-only{pointer-events:none}", ""]);
// Exports
exports.locals = {
	"container": "SingleFieldLookupAddressForm-module-container-3mA-j",
	"inputContainer": "SingleFieldLookupAddressForm-module-inputContainer-3HkVw",
	"postcodeInput": "SingleFieldLookupAddressForm-module-postcodeInput-17xaL"
};
module.exports = exports;
